import { useEffect } from "react";
import useUserProfile from "../hooks/useUserProfile";
import { Box, Typography, Chip, Grid, IconButton, Skeleton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import CallIcon from "@mui/icons-material/Call";
import moment from "moment";
import { useOrg } from "../../OrganizationPlugin/hooks/userOrg";
import CustomTypography from "../../../core/components/ui/CustomTypography";

export default function OrganizationDetailsComponent({ org_uid }) {

    const { loading, viewOrg, orgDetails, viewOrgSubscription, orgSubscriptionDetails } = useOrg();

    useEffect(() => { 
        if (org_uid) viewOrg(org_uid) 
    }, [org_uid]);

    useEffect(() => { 
        if (org_uid) {
            let query_params = {
                org_uid: org_uid
            }
            viewOrgSubscription(query_params)
        } 
    }, [org_uid]);

    const expirationDateFormatted = moment(orgSubscriptionDetails?.end_date).format("MMMM DD, YYYY");

    const organizationStatusStyles = {
        "Approved": { backgroundColor: '#e8f5e9', color: '#4caf50' },
        "Disapproved": { backgroundColor: '#F3F4F6', color: '#6B7280' }, 
        "Pending": { backgroundColor: '#FEF9C3', color: '#854D0E' },
    }

    return (
        <Box sx={{ mb: 4, p: 3, borderRadius: 3, boxShadow: 2, backgroundColor: '#fafafa' }}>
            <Box flex={1}>
                <CustomTypography
                    variant="h3"
                    text={"Organization Details"}
                    customStyles={{
                        marginBottom: 2, 
                        fontSize: 20,
                        fontWeight: 700
                    }}
                />
            </Box>
            <Box sx={{display:'flex', alignItems:'center'}}>
                {loading ? (
                    <Skeleton variant="text" width={200} height={30} />
                ) : (
                    <Typography variant="h5" fontWeight="bold" gutterBottom>
                        {orgDetails?.org_name || "NA"} 
                    </Typography>
                )}
                <Box sx={{flexGrow:1}}/>
                {loading ? (
                    <Skeleton variant="rounded" width={80} height={28} />
                ) : (
                    <Chip
                        label={orgDetails?.status}
                        style={organizationStatusStyles[orgDetails?.status] || {}}
                        size="small"
                    />
                )}
            </Box>

            {loading ? (
                <Skeleton variant="text" width="60%" height={20} />
            ) : (
                <Typography variant="body1" color="text.secondary" gutterBottom>
                    {orgDetails?.description || "NA"}
                </Typography>
            )}

            <Grid container spacing={2} sx={{mt: 2}}>
                <Grid size={{xs: 3}} sx={{mt: 1}}>
                    <Box sx={{display: "flex", alignItems: "center"}} gap={1}>
                        <Typography variant="body2" sx={{color:'gray'}}>Subscription Type: </Typography> 
                        {loading ? (
                            <Skeleton variant="text" width={100} height={20} />
                        ) : (
                            <Typography variant="body2">{orgSubscriptionDetails?.type || "NA"}</Typography>
                        )}
                    </Box>
                    <Box sx={{display: "flex", alignItems: "center", mt: 2}} gap={1}>
                        <Typography variant="body2" sx={{color:'gray'}}>Expiration Date: </Typography> 
                        {loading ? (
                            <Skeleton variant="text" width={140} height={20} />
                        ) : (
                            <Typography variant="body2">{expirationDateFormatted}</Typography>
                        )}
                    </Box>
                </Grid>
                <Grid size={{xs: 3}}>
                    <Box sx={{display: "flex", alignItems: "center"}} gap={1}>
                        <IconButton sx={{bgcolor:"#0b99da"}}>
                            <EmailIcon sx={{color:'#fff', height: 15, width: 15}}/>
                        </IconButton> 
                        {loading ? (
                            <Skeleton variant="text" width={180} height={20} />
                        ) : (
                            <Typography variant="body2">{orgDetails?.contact_email || "NA"}</Typography>
                        )}
                    </Box>

                    <Box sx={{display: "flex", alignItems: "center", mt: 1}} gap={1}>
                        <IconButton sx={{bgcolor:"#ff5353"}}>
                            <CallIcon sx={{color:'#fff', height: 15, width: 15}}/>
                        </IconButton> 
                        {loading ? (
                            <Skeleton variant="text" width={140} height={20} />
                        ) : (
                            <Typography variant="body2">{orgDetails?.contact_phone || "NA"}</Typography>
                        )}
                    </Box>
                </Grid>
            </Grid>

            <Typography variant="body2" color="text.secondary" sx={{mt: 2}}>
                {loading ? (
                    <Skeleton variant="text" width={200} height={20} />
                ) : (
                    <><strong>Date Registered:</strong> {moment(orgDetails?.created_at).format("MMMM DD, YYYY")}</>
                )}
            </Typography>
        </Box>
    );
}
